// var protocol = window.location.protocol == "https:" ? "https":"http";
// var server_URL = window.location.origin + "/";
// var server_url =protocol+ "://39.97.251.110:8081/";//超
// var server_URL = protocol+ "://api.mxl.mclandian.com/";//超

// var server_url = "http://sc.geemi.cn/";
//var server_url = "http://sc.geemi.cn/";
//var server_URL = "https://fm.yunkejia.com.cn/";
var server_URL = "https://api.mxl.mclandian.com/";
// http://sc.geemi.cn/timeloit/  正式
// https://transport.fanmeng.shop/timeloit/  正式
// https://fm.yunkejia.com.cn/timeloit   测试
let URL = server_URL + "tech_www";

//通用接口
const CommonURL = {
    checkPhoneIsExistsURL: URL + "wechatpublic/checkPhoneIsExists",//公众号-根据手机号检测是否存在
    getDictDataListByTypeURL: URL + "common/getDictDataListByType",//获取字典列表
    wechatCommitPhotoURL: URL + "wechatpublic/wechatCommitPhoto",//获取字典列表
    tech_wwwURL: URL,//数据提交
}

export default { server_URL,CommonURL};



// WEBPACK FOOTER //
// ./src/service/setting.service.js